import React from 'react';
import { Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import TransferDocumentation from "../../producer-dashboard/onecomm-transactions/TransferDocumentation";

type TransferFlowDocsAccordionProps = {
    expandedDocs: boolean;
    setExpandedDocs: (val: boolean) => void;
};

export const TransferFlowDocsAccordion = ({ expandedDocs, setExpandedDocs }: TransferFlowDocsAccordionProps) => {
    return (
        <Accordion
            expanded={expandedDocs}
            onChange={() => setExpandedDocs(!expandedDocs)}
            sx={{ mb: 4, boxShadow: 'none', border: '1px solid #e2e8f0', borderRadius: '16px !important', '&:before': { display: 'none' } }}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main' }} />}>
                <Typography variant="caption" sx={{ fontWeight: 800, display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary' }}>
                    <InfoIcon fontSize="small" color="primary" sx={{ fontSize: 16 }} /> TRANSFER FLOW DOCUMENTATION
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ bgcolor: '#f8fafc', p: 3, borderTop: '1px solid #e2e8f0', borderBottomLeftRadius: 16, borderBottomRightRadius: 16 }}>
                <TransferDocumentation />
            </AccordionDetails>
        </Accordion>
    );
};